import { css } from 'styled-components';
export const BKJThemeDropdown = {
    Square: css `
    box-shadow: 0px 2px 8px rgba(13, 51, 32, 0.3);
    background-color: ${({ theme }) => theme.colors.White};
  `,
    SeamlessRounded: css `
    background-color: ${({ theme }) => theme.colors.White};
    border: solid 1px ${({ theme }) => theme.colors.TextSubtleGrey};
    border-radius: 8px;
    ${({ $isOpen, openBorderLocation = 'top' }) => {
        const borderStyling = css `
        border-${openBorderLocation}: 0;
        border-${openBorderLocation}-color: ${({ theme }) => theme.colors.White};
        border-${openBorderLocation}-right-radius: 0px;
        border-${openBorderLocation}-left-radius: 0px;`;
        if ($isOpen)
            return css `
          ${borderStyling}
          opacity: 1;
          height: auto;
        `;
        else
            return css `
          ${borderStyling}
          display: none;
          opacity: 0;
        `;
    }};
  `,
};
//# sourceMappingURL=BKJDropdown.theme.js.map